// extracted by css-extract-rspack-plugin
export default {"container":"LeadingBadge-module__container__atIBm","titleLabel":"LeadingBadge-module__titleLabel__BPGG4","titleText":"LeadingBadge-module__titleText__2073Z"};